import React from 'react';
import { RouteObject } from 'react-router-dom';
import { LocalLogin } from './containers/LocalLogin';

export const localLoginRoutes: RouteObject = {
  path: 'local-login',
  element: <LocalLogin />,
};
